module.exports = __webpack_public_path__ + "static/intelius-logo-7a52582016f6b7e5b1ac1a934c8901e4.png";